import React from 'react';

import CustomTooltip from './CustomTooltip';
import { ToolTipProps } from './types';

import './styles.scss';

interface Props extends ToolTipProps {
  keys: string[];
}

export const shortcutTooltipTitle = (keys: string[], title: string | React.ReactNode) => {
  return (
    <div className="flex justify-center items-center w-full gap-2 ">
      <p className="flex justify-center items-center">{title}</p>
      {keys && keys?.length > 0 && (
        <div className="custom-shortcut-tooltip-key-section">
          {keys.map((key, i) => {
            return (
              <span className="custom-shortcut-tooltip-key" key={i}>
                {key}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

const CustomShortcutTooltip: React.FC<Props> = ({
  children,
  arrow = true,
  placement = 'bottom',
  light = false,
  show = true,
  opened,
  tooltipStyle = {},
  title,
  keys = [],
  ...rest
}) => {
  return (
    <CustomTooltip
      show={show}
      light={light}
      opened={opened}
      tooltipStyle={tooltipStyle}
      arrow={arrow}
      placement={placement}
      title={shortcutTooltipTitle(keys, title)}
      {...rest}>
      {children}
    </CustomTooltip>
  );
};

export default CustomShortcutTooltip;
